"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkSlaveSystem = void 0;
var realms_engine_1 = require("realms-engine");
var networkSlaveGameObject_1 = require("./networkSlaveGameObject");
var realms_engine_browser_1 = require("realms-engine-browser");
var realms_utils_1 = require("realms-utils");
var NetworkSlaveSystem = /** @class */ (function (_super) {
    __extends(NetworkSlaveSystem, _super);
    function NetworkSlaveSystem(client, 
    /*
     * Maps a network type to the factory method of making the gameObject
     */
    gameObjectFactoryMap, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, [networkSlaveGameObject_1.NetworkSlaveGameObject], []) || this;
        _this.client = client;
        _this.gameObjectFactoryMap = gameObjectFactoryMap;
        _this.options = options;
        _this.systemName = "NetworkSlaveSystem";
        /*
         * Maps the master gameObject id to the slave gameObject
         */
        _this.masterIdToSlave = new Map();
        _this.eventsBufferMap = new realms_utils_1.BufferMap(10);
        _this.client = client;
        _this.gameObjectFactoryMap = gameObjectFactoryMap;
        _this.client.addListener("onNetworkRealmEventMap", function (e) {
            return _this.onNetworkRealmEventMap(e);
        });
        return _this;
    }
    NetworkSlaveSystem.prototype.onNetworkRealmEventMap = function (e) {
        var e_1, _a, e_2, _b;
        var _c;
        try {
            for (var _d = __values(Object.entries(e)), _e = _d.next(); !_e.done; _e = _d.next()) {
                var _f = __read(_e.value, 2), gameObjectId = _f[0], events = _f[1];
                var id = Number(gameObjectId);
                var networkSlaveGameObject = this.masterIdToSlave.get(id);
                // Emit event
                if (networkSlaveGameObject) {
                    try {
                        for (var events_1 = (e_2 = void 0, __values(events)), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()) {
                            var event_1 = events_1_1.value;
                            networkSlaveGameObject.onNetworkEvent(event_1);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (events_1_1 && !events_1_1.done && (_b = events_1.return)) _b.call(events_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
                else {
                    // Store in buffer
                    var oldEvents = (_c = this.eventsBufferMap.get(id)) !== null && _c !== void 0 ? _c : [];
                    this.eventsBufferMap.set(id, __spreadArray(__spreadArray([], __read(oldEvents), false), __read(events), false));
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    NetworkSlaveSystem.prototype.onTargetGameObjectEnter = function (gameObject) {
        var e_3, _a;
        var _b;
        if (gameObject instanceof networkSlaveGameObject_1.NetworkSlaveGameObject) {
            this.masterIdToSlave.set(gameObject.masterGameObjectId, gameObject);
            // Emit all the buffered events
            var events = (_b = this.eventsBufferMap.get(gameObject.id)) !== null && _b !== void 0 ? _b : [];
            try {
                for (var events_2 = __values(events), events_2_1 = events_2.next(); !events_2_1.done; events_2_1 = events_2.next()) {
                    var event_2 = events_2_1.value;
                    gameObject.onNetworkEvent(event_2);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (events_2_1 && !events_2_1.done && (_a = events_2.return)) _a.call(events_2);
                }
                finally { if (e_3) throw e_3.error; }
            }
            this.eventsBufferMap.delete(gameObject.id);
        }
    };
    NetworkSlaveSystem.prototype.onTargetGameObjectExit = function (gameObject) {
        if (gameObject instanceof networkSlaveGameObject_1.NetworkSlaveGameObject) {
            this.masterIdToSlave.delete(gameObject.masterGameObjectId);
        }
    };
    NetworkSlaveSystem.prototype.getClient = function () {
        return this.client;
    };
    NetworkSlaveSystem.prototype.onGameStepStart = function (delta, realm) {
        var e_4, _a, e_5, _b;
        // Get current client state and sync that with client realm
        var currState = this.client.getCurrentMasterState();
        // Have not received first state yet so do nothing
        if (currState === null) {
            return;
        }
        // Call listeners
        this.dispatch("onStateStep", currState);
        if (this.options.debugState) {
            realms_engine_browser_1.DebugPanel.logObject("NetworkSlaveSystem:state", currState);
        }
        // All slave gameObject master ids currently existing
        var existingMasterIds = new Set(this.masterIdToSlave.keys());
        try {
            for (var _c = __values(currState.gameObjects), _d = _c.next(); !_d.done; _d = _c.next()) {
                var newGameObjectState = _d.value;
                var masterId = newGameObjectState.id;
                var gameObject = this.masterIdToSlave.get(masterId);
                // New slave gameObject
                if (gameObject === undefined) {
                    // Create slave gameObject
                    var gameObject_1 = this.gameObjectFactoryMap[newGameObjectState.type](newGameObjectState.state, realm);
                    var slaveGameObject = new networkSlaveGameObject_1.NetworkSlaveGameObject(gameObject_1, masterId);
                    realm.scene.add(slaveGameObject);
                }
                else {
                    // Update existing entity
                    gameObject.setState(newGameObjectState.state);
                    existingMasterIds.delete(masterId);
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_4) throw e_4.error; }
        }
        try {
            // All left over ids have been deleted from the master realm
            // so remove them in the client realm
            for (var existingMasterIds_1 = __values(existingMasterIds), existingMasterIds_1_1 = existingMasterIds_1.next(); !existingMasterIds_1_1.done; existingMasterIds_1_1 = existingMasterIds_1.next()) {
                var masterId = existingMasterIds_1_1.value;
                var slaveGameObject = this.masterIdToSlave.get(masterId);
                if (slaveGameObject !== undefined) {
                    realm.scene.remove(slaveGameObject);
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (existingMasterIds_1_1 && !existingMasterIds_1_1.done && (_b = existingMasterIds_1.return)) _b.call(existingMasterIds_1);
            }
            finally { if (e_5) throw e_5.error; }
        }
    };
    return NetworkSlaveSystem;
}(realms_engine_1.System));
exports.NetworkSlaveSystem = NetworkSlaveSystem;
